import * as contactHooks from "@rentiohq/shared-frontend/dist/redux/contact/contact.hooks";
import * as chatHooks from "@rentiohq/shared-frontend/dist/reduxV2/chats/chat.hooks";
import { useParams } from "react-router-dom";
import { ContactDashboard } from "./ContactDashboard";

export const ContactDashboardContainer = () => {
  const params = useParams<{ contactId: string }>();
  const contactId = params.contactId ? +params.contactId : undefined;

  const { detail: contact } = contactHooks.useDetail({
    id: contactId,
    shouldRefetch: false,
  });

  const {
    items: chats,
    isFetching: isFetchingChats,
    fetchError: chatsFetchError,
  } = chatHooks.usePaged(
    contactId
      ? {
          shouldRefetch: true,
          query: {
            limit: 100,
            page: 1,
          },
          customPath: `/contacts/${contactId}/chats`,
        }
      : {
          shouldRefetch: true,
        },
  );

  if (!contact) {
    return null;
  }

  return (
    <ContactDashboard
      contact={contact}
      chats={chats}
      isFetchingChats={isFetchingChats}
      chatsFetchError={chatsFetchError}
    />
  );
};
